const validateForms = document.querySelectorAll('form._wf_validate');

const removeInvalidOnValidChange = (e) => {
  const valid = e.target.checkValidity();
  if (valid) {
    e.target.classList.remove('_invalid');

    // Custom date fields
    // e.target.closest('birth-date-field').classList.remove('_input_completed');

    e.target.removeEventListener('change', removeInvalidOnValidChange);
  }
  return valid;
}

Array.from(validateForms).forEach(form => {
  const formFields = Array.from(form.querySelectorAll('input, select'));
  formFields.forEach(field => {
    field.addEventListener('blur', e => {
      if (!field.checkValidity()) {
        field.classList.add('_invalid');
        field.addEventListener('change', removeInvalidOnValidChange);
      }
    })
  });

  // Custom date fields
  const birthDateFields = Array.from(form.querySelectorAll('birth-date-field input'));
  birthDateFields.forEach(field => {
    field.addEventListener('blur', e => {
      field.closest('birth-date-field').classList.add('_input_completed');
    });
  });
});

const asyncSubmitForms = document.querySelectorAll('form._wf_async_submit');
Array.from(asyncSubmitForms).forEach(form => {

  Array.from(form.querySelectorAll('input[type="submit"]')).forEach(submitInput => {
    submitInput.addEventListener('click', e => {
      form.classList.add('_submit_attempted');
      Array.from(form.querySelectorAll('birth-date-field')).forEach(dateInput => {
        dateInput.classList.add('_submit_attempted');
      });
    });
  });

  const { action, method, enctype } = form;

  let busy = false;
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (busy === true) {
      return false;
    }

    console.log(e);

    const submitInput = form.querySelector('input[type="submit"]');
    const normalText = submitInput.value;
    submitInput.value = '...';
    busy = true;
    form.classList.add('_busy');

    const formData = new FormData(form);

    let headers = {};
    let body;

    switch (enctype) {
      case 'multipart/form-data':
        body = formData;
        break;
      case 'application/x-www-form-urlencoded':
        headers['Content-Type'] = 'application/x-www-form-urlencoded';
        body = new URLSearchParams(formData);
        break;
      default:
        console.log(`What's a ${ enctype }?`);
        return false;
    }

    let response;

    try {
      response = await fetch(action, {
        method,
        headers,
        body,
      });
    } catch(err) {
      console.warn('Error fetching', response, err);
      alert('Please upload a smaller image, max is 10MB');

      submitInput.value = normalText;
      busy = false;
      form.classList.remove('_busy');
      return;
    }

    if (!response?.ok) {
      alert('Something went wrong, please try again');
      submitInput.value = normalText;
      busy = false;
      form.classList.remove('_busy');
      return;
    }

    const responseBody = await response.json();

    console.log('response', response, responseBody);

    const { success, errors } = responseBody;

    if (success) {
      // alert('redirect');
      // submitInput.value = normalText;
      window.location.search = 'step=thanks&view=wfu_rebrand_applications';
      console.log(responseBody);
      return;
    }

    const translatedErrors = errors.map(error => {
      if (error?.message === 'duplicate key value violates unique constraint "entries_email_key"') {
        return 'This email is already taken';
      }

      if (error?.message) {
        return error.message;
      }

      return error;
    });

    submitInput.value = normalText;
    busy = false;
    form.classList.remove('_busy');
    alert(JSON.stringify(translatedErrors.join('\n')));
  });
});
